import React from 'react';
import { itemFilterTypes } from '../../../constants';
import FilterGroup from './filter-group';

const ContentFilterGroup = ({ onApply }) => {
  const activeFilters = [
    itemFilterTypes.cpdCategory,
    itemFilterTypes.publisher,
    itemFilterTypes.association,
    itemFilterTypes.contentType,
    itemFilterTypes.contentLength,
    itemFilterTypes.bookmark,
  ]

  return <span id='goal-content-filter-group'>
    <FilterGroup {...{
      activeFilters,
      onApply
    }} />
  </span>
}

export default ContentFilterGroup


// WEBPACK FOOTER //
// ./src/containers/components/filters/goal-content-filter-group.js